<div class="vision-board" *ngIf="groups.length; else emptyEpics">
  <section class="vb-category" *ngFor="let grp of groups">
    <div class="vb-cat-header">
      <span class="vb-cat-icon" [style.background]="grp.category.color"><i [class]="grp.category.icon"></i></span>
      <h4>{{ grp.category.name }}</h4>
      <div class="vb-progress">
        <span class="vb-progress-label">{{ grp.achieved }}/{{ grp.total }} conseguidas</span>
        <div class="vb-progress-bar">
          <div class="vb-progress-fill" [style.width.%]="grp.progress" [style.background]="grp.category.color"></div>
        </div>
      </div>
    </div>

    <div class="vb-grid">
      <div class="vb-goal" *ngFor="let e of grp.epics; let gi = index" [ngClass]="'gs-' + e.status"
        [style.border-top-color]="grp.category.color" [style.animation-delay.ms]="gi * 60"
        (click)="onEpic(e)" (keydown.enter)="onEpic(e)" role="button" tabindex="0">
        <div class="vb-goal-top">
          <span class="vb-goal-icon" [style.color]="grp.category.color"><i [class]="e.epic.icon"></i></span>
          <span class="vb-status">
            <i [class]="EPIC_STATUS_META[e.status].icon" [style.color]="EPIC_STATUS_META[e.status].color"></i>
            <span [style.color]="EPIC_STATUS_META[e.status].color">{{ EPIC_STATUS_META[e.status].label }}</span>
          </span>
        </div>
        <div class="vb-goal-title">{{ e.epic.title }}</div>

        <!-- Avance real: sale de las tareas, no de una etiqueta escrita a mano -->
        <div class="vb-work" *ngIf="e.taskCount">
          <div class="vb-work-bar">
            <div class="vb-work-fill" [style.width.%]="progressOf(e)" [style.background]="EPIC_STATUS_META[e.status].color"></div>
          </div>
          <span class="vb-work-lbl">{{ e.doneCount }}/{{ e.taskCount }} tareas<span *ngIf="e.points"> · {{ e.points }} pts</span></span>
        </div>

        <div class="vb-goal-foot">
          <span class="vb-date" [class.muted]="!e.epic.date">
            <i class="fa-regular fa-calendar"></i> {{ epicDate(e) }}
          </span>
          <span class="vb-team" *ngIf="e.epic.origin === 'proposed'" title="Iniciativa del equipo interno de TI">
            <i class="fa-solid fa-lightbulb"></i> Idea de TI
          </span>
        </div>
      </div>
    </div>
  </section>
</div>

<ng-template #emptyEpics>
  <div class="vb-empty">Sin épicas registradas.</div>
</ng-template>
